<template>
  <dialog class="menu" ref="dialogRef" @click="close" @keyup.esc="close">
    <div class="content" @click.stop>
      <div class="top-bar">
        <IconButton @click.stop="close" variant="ghost" icon="x-close" />
      </div>
      <nav class="navigation">
        <router-link v-for="link in mainNavigationConfig" :key="link.title" :to="{ name: link.appRoute }" class="link">
          {{ link.title }}
        </router-link>
      </nav>

      <Button variant="outline" size="medium" @click="logout()" class="log-out">
        <span>Log out</span>
        <Icon name="log-out-03" />
      </Button>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { Button, IconButton, Icon } from '@tallo/design-system';
import { mainNavigationConfig } from '@tallo/investor/navigation';

const emit = defineEmits(['logout']);

const opened = ref(false);
const dialogRef = ref<HTMLDialogElement>();

const open = () => {
  opened.value = true;
  dialogRef.value?.show();
};

const close = () => {
  opened.value = false;
  dialogRef.value?.close();
};

const logout = () => {
  close();
  emit('logout');
};

useRouter().beforeEach(() => {
  if (opened.value) {
    close();
  }
});

defineExpose({
  open,
  close,
});
</script>

<style scoped lang="scss">
.menu {
  width: 100%;
  height: 100vh;
  border: none;
  padding: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.content {
  background-color: white;
}

.top-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 1rem;
  height: var(--t-header-height-mobile);
}

.navigation {
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem;

  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
}

.link {
  padding: 0.75rem 0.5rem;
  border-radius: var(--t-border-radius-sm);

  &.router-link-active {
    background-color: #f5f5f5;
  }
}

.log-out {
  margin-top: 1.25rem;
  margin-bottom: 1.5rem;
  margin-left: 1.5rem;
}
</style>
